var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.86785,
    cy: 7.5,
    rx: 7.33929,
    ry: 7.5,
    fill: "#6C5CE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86785 4.5C4.93213 4.5 3.83124 7.5 3.83124 7.5C3.83124 7.5 4.93213 10.5 7.86785 10.5C10.8036 10.5 11.9045 7.5 11.9045 7.5C11.9045 7.5 10.8036 4.5 7.86785 4.5ZM7.86785 5.625C8.88103 5.625 9.70267 6.46463 9.70267 7.5C9.70267 8.53538 8.88103 9.375 7.86785 9.375C6.85466 9.375 6.03302 8.53538 6.03302 7.5C6.03302 6.46463 6.85466 5.625 7.86785 5.625ZM7.86785 6.375C7.57587 6.375 7.29585 6.49353 7.0894 6.7045C6.88294 6.91548 6.76695 7.20163 6.76695 7.5C6.76695 7.79837 6.88294 8.08452 7.0894 8.2955C7.29585 8.50647 7.57587 8.625 7.86785 8.625C8.15982 8.625 8.43984 8.50647 8.64629 8.2955C8.85275 8.08452 8.96874 7.79837 8.96874 7.5C8.96874 7.20163 8.85275 6.91548 8.64629 6.7045C8.43984 6.49353 8.15982 6.375 7.86785 6.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.1895a6dd70c50a4fdb969fded94800c5.svg";
export { ForwardRef as ReactComponent };